import styled from 'styled-components';
import { AgentToolBarStyled } from '../AgentToolBarStyled';

export const AgentToolBarStyledDS = styled(AgentToolBarStyled)`
    background: ${({ theme }) => theme.colors.secondary};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;
